var calledFromGeoIp = false;
(function ($) {
    $(document).ready(function () {
        if ($('.sp01-map').length) {
            var mapId = $('.sp01-map').attr('id');
        }
    });

    var showconsent = $('.component.sp01-map').attr('data-show-consent');

    if (showconsent == 'false') {
        $(window).on('load', mapdetailinit);
    } else {
        $('.component.sp01-map').addClass('hide-map-div');
    }

}(window.jQuery));

function mapdetailinit() {
    var $maps = $('.component.sp01-map');
    if ($('.sp01-map').length) {
        var mapIdBaidu = $('.sp01-map').attr('id');
    }
    if (!$maps.length) return false;
    $maps.each(function () {
        var self = $(this);
        loadMapify(self.data('map-provider'));
        var mapOptions = JSON.stringify(self.data('map-options')),
            data = $.parseJSON(mapOptions);
        data.pins = generatePinsList(self);
        setMapPins(self, data);
    });
    if ($('.btn-direction-loc').length > 0) {
        var getDirectionsUrl = $('.btn-direction-loc a,a.directionBtnMobile');
        for (var i = 0; i < getDirectionsUrl.length; i++) {
            $(getDirectionsUrl[i]).attr("href", $(getDirectionsUrl[i]).attr("href").split("#").join(""));
        }
        replaceHrefForKhws();
        replaceButtonHref();

        if ($('.sp01-map').length) {
            var mapId = $('.sp01-map').attr('id');
            var lastSearchTermInLocator = JSON.parse(decodeURIComponent(window.sessionStorage.getItem("lastSearchTermInLocator")));
            if (lastSearchTermInLocator == null || lastSearchTermInLocator == "null") {
                if (mapId != "baiduMap" && mapId !=="tencentMap" ) {
                    getGeoIps();
                }
                else if (mapId === "baiduMap") {
                    replaceNameLocationForBaidu();
                }  else if (mapId === "tencentMap") {
                    replaceNameLocationForTencent();
                }
            }
        }
    }
}
function formatUrlAndAssign(url) {
    var formattedUrl = url.replace("#", "");
    $('.btn-direction-loc a,a.directionBtnMobile').attr('href', formattedUrl);
}
function replaceButtonHref() {
    if (!$('.sp01-map').length) {
        return;
    }
    var mapId = $('.sp01-map').attr('id');
    var lastSearchTermInLocator = JSON.parse(decodeURIComponent(window.sessionStorage.getItem("lastSearchTermInLocator")));
   
    var miHref = $('.btn-direction-loc a').attr('href');
    var hrefSplit;
    if (lastSearchTermInLocator !== null && lastSearchTermInLocator !== "null") {
        var tempObj = lastSearchTermInLocator;
        var geoCoords = tempObj.userLocation.lat + "," + tempObj.userLocation.lng;
        if (mapId !== "baiduMap" && mapId !== "tencentMap") {
            setUserLatitudeAndLongitude(geoCoords, miHref, mapId);
        } else if (mapId === "baiduMap") {
            hrefSplit = miHref.split('origin=latlng:');
            var beforeOrigin = hrefSplit[0];
            var afterOrigin = hrefSplit[1];
            var afterOriginSplit = afterOrigin.split('|');
            var latlngorigin = tempObj.userLocation.lat + "," + tempObj.userLocation.lng;
            var finalURL1 = beforeOrigin + 'origin=latlng:' + latlngorigin + '|' + afterOriginSplit[1] + '|' + afterOriginSplit[2];
            var description = tempObj.userLocation.originName;
            var nameSplit = finalURL1.split('name:');
            var destination = (nameSplit[1]).split('&destination=')[1];
            var finalURL = nameSplit[0] + 'name:' + description + '&destination=' + destination + 'name:' + nameSplit[2];
            formatUrlAndAssign(finalURL);
            $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
        } else if (mapId === "tencentMap") {
            let copyMiHref = JSON.parse(JSON.stringify(miHref))
            copyMiHref = copyMiHref.replace('origin', tempObj.userLocation.originName);
            const originCordsFirstPart = copyMiHref.split('fromcoord=');
            const finalUrlOriginCords = originCordsFirstPart[0] + 'fromcoord=' + geoCoords + originCordsFirstPart[1];

            formatUrlAndAssign(finalUrlOriginCords);
            $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
        }
    }

    if ($('#schemaorg-locator').length) {
        if (mapId == "baiduMap") {
            var schemaOrg = JSON.parse($('#schemaorg-locator').html());
            if (schemaOrg.address) {
                var address = schemaOrg.address.streetAddress + ' ' + schemaOrg.address.addressLocality;
                var btnHref = $('.btn-direction-loc a').attr('href');
                var replaceString = address.length > 0 ? '|name:' + address : '|name:destination';
                btnHref = btnHref.replace('|name:destination', replaceString);
                formatUrlAndAssign(btnHref);
            }
        }

        if (mapId == "tencentMap") {
            var schemaOrg = JSON.parse($('#schemaorg-locator').html());
            if (schemaOrg.address) {
                var address = schemaOrg.address.streetAddress + ' ' + schemaOrg.address.addressLocality;
                var btnHref = $('.btn-direction-loc a').attr('href');
                btnHref = btnHref.replace('destination', address ?? 'destination');
                formatUrlAndAssign(btnHref);
            }
        }
    }

}

function replaceNameLocationForBaidu() {
    if (!$('.sp01-map').length) return false;
    var miHref = $('.btn-direction-loc a').attr('href');
    var latlng = miHref.split('latlng:');
    var latlngorigin = latlng[1].split('|name:')[0];
    var latlngdestiny = latlng[2].split('|name:')[0];
    getBaiduName(latlngorigin, 'o');
    if (latlng[2].split('|name:')[1].split("&mode")[0] === "destination") {
        getBaiduName(latlngdestiny, 'd');
    }
}

function replaceNameLocationForTencent() {
    if (!$('.sp01-map').length) return false;
    var miHref = $('.btn-direction-loc a').attr('href');

    let latlngorigin = miHref.split('fromcoord=')[1].split('&')[0];
    let latlngdestiny = miHref.split('tocoord=')[1].split('&')[0];

    getTencentName(latlngorigin, 'o');
    if (miHref.includes('destination')) getTencentName(latlngdestiny, 'd');
}

function replaceHrefForKhws() {
    if (!$('.sp01-map').length) return false;
    var mapId = $('.sp01-map').attr('id');
    var miHref = $('.btn-direction-loc a').attr('href');
    var hrefSplit = miHref.split('&origin=');
    var origin, destiny, finalURL = '';
    if (hrefSplit.length > 1) {
        origin = hrefSplit[1];
        destiny = (hrefSplit[0]).split('&query=')[1];
        switch (mapId) {
            case "googleMap":
                finalURL = 'https://maps.google.com?daddr=' + destiny + '&saddr=' + origin;
                formatUrlAndAssign(finalURL);
                $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
                break;
            case "yandexMap":
                finalURL = 'https://yandex.ru/maps/?rtext=' + encodeURIComponent(origin) + '~' + encodeURIComponent(destiny) + '&rtt=mt';
                formatUrlAndAssign(finalURL);
                $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
                break;
            case "baiduMap":
                break;
            case "tencentMap":
                break;
            case "bingMap":
                finalURL = 'https://www.bing.com/maps?rtp=pos.' + origin.split(",").join("_") + '~pos.' + destiny.split(",").join("_");
                formatUrlAndAssign(finalURL);
                $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
                break;
        }
    }

}

function getGeoIps() {
    var mapId = $('.sp01-map').attr('id');
    if (mapId == "baiduMap") {
        var geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function (r) {
            if (this.getStatus() == 0) {
                calledFromGeoIp = true;
                var miHref = $('.btn-direction-loc a').attr('href');
                hrefSplit = miHref.split('origin=latlng:');
                var beforeOrigin = hrefSplit[0];
                var afterOrigin = hrefSplit[1];
                var afterOriginSplit = afterOrigin.split('|');
                var latlngorigin = r.latitude + "," + r.longitude;
                var finalURL1 = beforeOrigin + 'origin=latlng:' + latlngorigin + '|' + afterOriginSplit[1] + '|' + afterOriginSplit[2];
                formatUrlAndAssign(finalURL1);
                getBaiduName(latlngorigin, 'o');
            }
            else {
                catchError(r);
            }
        }, function (err) {
            $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
        });
    } else if (mapId === "tencentMap") {
        $.ajax({
            url: `https://apis.map.qq.com/ws/location/v1/ip?key=TY2BZ-G4FLL-LLLPD-EH4ZS-3YGLK-AIF5N`,
            type: "GET",
            crossDomain: true
        }).then(function(result) {
            if (result.status === 0 && result.result.location && result.result.ad_info.adcode !== -1) {
                    calledFromGeoIp = true;
                    var miHref = $('.btn-direction-loc a').attr('href');

                    let finalURL1 = miHref.replace('{0}', `${result.result.location.lat},${result.result.location.lng}`) 
                    formatUrlAndAssign(finalURL1);
                    getTencentName(`${result.result.location.lat},${result.result.location.lng}`, 'o');
                    
                } else {
                    catchError(result);
                }
        });
      
    } else if (navigator.geolocation) {
        $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
        navigator.geolocation.getCurrentPosition(changeURL, catchError);
    } else {

    }
}

function changeURL(position) {
    if (position) {
        attachEventHandler(".product-locator", "allow-location", true, "allow-location");
        attachEventHandler(".product-locator-ff", "allow-location", true, "allow-location");
    }
    if ($('.sp01-map').length > 0) {
        var mapId = $('.sp01-map').attr('id');
        var miHref = $('.btn-direction-loc a').attr('href');
        if (mapId == "baiduMap") {
            return;
        }
        var geoCoords = position.coords.latitude + "," + position.coords.longitude;
        setUserLatitudeAndLongitude(geoCoords, miHref, mapId);
    }


}
function setUserLatitudeAndLongitude(geoCoords, miHref, mapId) {

    var hrefSplit, destLatLong, finalURL = '';
    switch (mapId) {
        case "googleMap":
            hrefSplit = miHref.split('daddr=');
            var beforeDaddr = hrefSplit[0];
            var afterDaddr = hrefSplit[1];
            destLatLong = afterDaddr.split('&')[0];
            finalURL = beforeDaddr + 'daddr=' + destLatLong + '&saddr=' + geoCoords;
            formatUrlAndAssign(finalURL);
            $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
            break;
        case "yandexMap":
            hrefSplit = miHref.split('rtext=');
            var beforeRtxt = hrefSplit[0];
            var afterRtxt = hrefSplit[1];
            destLatLong = afterRtxt.split('~')[1];
            var geoCoordsEncode = encodeURIComponent(geoCoords);
            finalURL = beforeRtxt + 'rtext=' + geoCoordsEncode + '~' + destLatLong;
            formatUrlAndAssign(finalURL);
            $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
            break;
        case "bingMap":
            hrefSplit = miHref.split('pos.');
            var beforeOriginLatLong = hrefSplit[0];
            destLatLong = hrefSplit[2];
            finalURL = beforeOriginLatLong + 'pos.' + geoCoords.split(",").join("_") + '~pos.' + destLatLong;
            formatUrlAndAssign(finalURL);
            $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
            break;

    }
}
function getBaiduName(position, direction) {
    var posLat = parseFloat(position.split(',')[0]);
    var posLon = parseFloat(position.split(',')[1]);
    var description = "";

    if (direction == 'o') {
        $.ajax({
            url: "https://api.map.baidu.com/telematics/v3/reverseGeocoding?location=" + posLon + "," + posLat + "&coord_type=gcj02&ak=4Kq2FM6g8buv7oQaYzt3t9cY&output=json",
            type: "GET",
            xhrFields: { withCredentials: true },
            dataType: 'jsonp',
            jsonpCallback: 'myCallBackMethod',
            async: false, // this is by default false, so not need to mention
            crossDomain: true // tell the browser to allow cross domain calls.

        });
    } else {
        $.ajax({
            url: "https://api.map.baidu.com/telematics/v3/reverseGeocoding?location=" + posLon + "," + posLat + "&coord_type=gcj02&ak=4Kq2FM6g8buv7oQaYzt3t9cY&output=json",
            type: "GET",
            xhrFields: { withCredentials: true },
            dataType: 'jsonp',
            jsonpCallback: 'myCallBackMethodD',
            async: false, // this is by default false, so not need to mention
            crossDomain: true // tell the browser to allow cross domain calls.			  
        });
    }
}

function getTencentName(position, direction) {
    const [lat, lng] = position.split(',').map(parseFloat);
    
    if (direction == 'o') {
        $.ajax({
            url: `https://apis.map.qq.com/ws/geocoder/v1/?location=${lat},${lng}&key=TY2BZ-G4FLL-LLLPD-EH4ZS-3YGLK-AIF5N&output=jsonp`,
            type: "GET",
            dataType: 'jsonp',
            jsonpCallback: 'callback',
            crossDomain: true
        }).then(function(data) {
            tencentCallbackMethod(data, 'origin');
        });
    } else {
        $.ajax({
            url: `https://apis.map.qq.com/ws/geocoder/v1/?location=${lat},${lng}&key=TY2BZ-G4FLL-LLLPD-EH4ZS-3YGLK-AIF5N&output=jsonp`,
            type: "GET",
            dataType: 'jsonp',
            jsonpCallback: 'callback',
            crossDomain: true
        }).then(function(data) {
            tencentCallbackMethod(data, 'destination');
        });
    }

}

window.myCallBackMethod = function (data) {
    successResponse(data);
};

window.tencentCallbackMethod = function (data, location) {
    successTencentResponse(data, location);
};


successResponse = function (data) {
    var description = data.description;
    if (description == '') description = data.city;
    if ($('.btn-direction-loc a').length > 0 && $('#baiduMap').length > 0) {
        var buttonHref = $('.btn-direction-loc a').attr('href');
        var nameSplit = buttonHref.split('name:');
        var destination = (nameSplit[1]).split('&destination=')[1];
        var finalURL = nameSplit[0] + 'name:' + description + '&destination=' + destination + 'name:' + nameSplit[2];
        formatUrlAndAssign(finalURL);
        if (!calledFromGeoIp) {
            getGeoIps();
        }
        else {
            $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
        }
    }

};

successTencentResponse = function (data, location) {
    if (data.status === 0 && data.result) {
        let address = data.result.address;

        if ($('.btn-direction-loc a').length > 0 && $('#tencentMap').length > 0) {
            var buttonHref = $('.btn-direction-loc a').attr('href');
            let finalURL = buttonHref.replace(location, address);
            formatUrlAndAssign(finalURL);
            
            if (!calledFromGeoIp) {
                getGeoIps();
            }
            else {
                $('.btn-direction-loc a,a.directionBtnMobile').removeClass("d-none");
            }
        }
    }
};

window.myCallBackMethodD = function (data) {
    successResponseD(data);
};

successResponseD = function (data) {
    var description = data.description;
    if (description == '') description = data.city;
    if ($('.btn-direction-loc a').length > 0 && $('#baiduMap').length > 0) {
        var myHref = $('.btn-direction-loc a').attr('href');
        var nameSplit = myHref.split('name:');
        var mode = (nameSplit[2]).split('&mode=')[1];
        var finalURL = nameSplit[0] + 'name:' + nameSplit[1] + 'name:' + description + '&mode=' + mode;
        formatUrlAndAssign(finalURL);
    }
};


function catchError(positionError) {
    if (positionError) {
        attachEventHandler(".product-locator", "block-location", true, "block-location");//
        attachEventHandler(".product-locator-ff", "block-location", true, "block-location");//
    }
    switch (positionError.code) {
        case positionError.TIMEOUT:

            break;
        case positionError.POSITION_UNAVAILABLE:
            break;
        case positionError.PERMISSION_DENIED:
            break;

    }
}

function getPinColor() {
    var colors = ['Blue', 'Red', 'Yellow'],
        pinColor = 'blue';
    $.each(colors, function (ind, color) {
        if ($('link[href*=WEP-' + color + ']').length) {
            pinColor = color;
        }
    });
    return {
        pinClass: 'icon-map-pin-' + pinColor + '-small',
        pinURI: '/Assets/img/icons/icon-map-pin-' + pinColor.toLowerCase() + '-small.png'
    };
}

function setMapPins(aMap, data) {
    var zoomMap = data.options.zoom;
    var latitudeMap = data.options.center.latitude;
    var longitudeMap = data.options.center.longitude;
    if (zoomMap != "") {
        zoomMap = parseInt(zoomMap);
    }
    else {
        zoomMap = 10;
    }
    if (latitudeMap !== "") {
        latitudeMap = parseFloat(latitudeMap);
    }

    if (longitudeMap !== "") {
        longitudeMap = parseFloat(longitudeMap);
    }
    var aMapProvider = aMap.data('map-provider');
    var isGoogle = aMapProvider.toUpperCase() == "GOOGLE";
    var pinInfo = getPinColor(),
        pinImage = "/assets/img/icons/icon-map-pin-blue-small.png",
        pinClassName = pinInfo.pinClass,
        pinHeight = data.options.pin && data.options.pin.height ? data.options.pin.height : 34,
        pinWidth = data.options.pin && data.options.pin.width ? data.options.pin.width : 20,
        center = data.options.center,
        mapifyOptions = {
            key: data.options.key,
            type: data.options.type,
            disableMouse: data.options.disableMouse,
            disableZoom: true,
            mapType: data.options.mapType,
            showScale: data.options.showScale,
            zoom: zoomMap,
            pin: {
                cssClass: pinClassName,
                image: pinImage,
                height: pinHeight,
                width: pinWidth
            }
        };
    if (center && latitudeMap && longitudeMap) {
        mapifyOptions.center = { latitude: latitudeMap, longitude: longitudeMap };
    }
    var defaultPin = { position: { latitude: latitudeMap, longitude: longitudeMap } };
    aMap.mapify(mapifyOptions);

    var duplicated = isDuplicated();
    var mapPins = $('.sp01-map').data('map-pins');
    if (data.pins && data.pins.length) {

        if (!duplicated) {
            data.pins.push(defaultPin);
        }
        aMap.mapify('setPins', data.pins);

    } else {
        var defaultPinArray = [];
        defaultPinArray.push(defaultPin);
        aMap.mapify('setPins', defaultPinArray);
    }

    aMap.mapify('setBoundaryToPins');
    setTimeout(function () {
        var arr = $('img');
        arr.each(function (component, index) {
            var imgSrc = $(this).attr('src');
            if (imgSrc.includes('transparent.png')) {
                $(this).parent().attr('tabindex', '-1');
            }
        });
    }, 5000);
}
function isDuplicated() {
    var mapOptions = JSON.parse($('.sp01-map').attr('data-map-options'));

    var mapPins = $('.sp01-map').data('map-pins');
    if (mapPins) {
        if (mapOptions.options.center.latitude == mapPins[0].Latitude && mapOptions.options.center.longitude == mapPins[0].Longitude) {
            return true;
        }
        else {
            return false;
        }
    }
}
function loadMapify(mapProvider) {
    if (!mapProvider) return false;
    var mapifyID = 'mapify-' + mapProvider,
        mapifyURI = '/assets/js/plugins/' + mapifyID + '.js';
    if (!$('#' + mapifyID).length) {
        $('body').append('<script id="' + mapifyID + '" src=' + mapifyURI + '?v=1"/>');
    }
}

function generatePinsList($map) {
    if (!$map.length) return false;
    var pinsArray = $map.data('map-pins'),
        pinsList = [],
        isChemicalDistributor = $map.data('map-options').options.isChemicalDistributor,
        title, url, eventInfo, startDate, endDate, city, province, country, pinImage, phone,
        mapType = $map.data('map-options').options.type;
    if (!pinsArray.length) {
        return pinsArray;
    } else {
        $.each(pinsArray, function (i, item) {
            if (item.Latitude && item.Longitude) {
                title = item.Title.replace(/\"/g, "") || '';
                url = item.Url || '';
                startDate = item.StartDate || '';
                endDate = item.EndDate || '';
                if (item.City && item.City !== '') {
                    city = item.City + ', ';
                }
                else {
                    city = '';
                }
                if (item.Province && item.Province !== '') {
                    province = item.Province + ', ';
                }
                else {
                    province = '';
                }
                country = item.Country || '';
                phone = item.Phone || '';
                pinImage = item.PinImage || "/assets/img/icons/icon-map-pin-blue-small.png";
                if (mapType == "Events") {
                    eventInfo = '{"image": "' + item.PinImage + '","details": "<b>' + title + '</b>","position": { "latitude": ' + item.Latitude + ', "longitude": ' + item.Longitude + '}, "popup": "<div class=' + "'map-popup-info'" + '><span class=' + "'map-popup-title'" + '><strong><a href=' + "'" + url + "'" + ' target=' + "'" + '_blank' + "'" + '>' + title + '</a></strong></span><br/><div>' + startDate + '</div><div>' + endDate + '</div><div>' + city + '' + province + '' + country + '</div></div > "}';
                } else if (mapType == "RetailLocator") {
                    eventInfo = '{"image": "' + item.PinImage + '","details": "<b>' + title + '</b>","position": { "latitude": ' + item.Latitude + ', "longitude": ' + item.Longitude + '}, "popup": "<div class=' + "'map-popup-info'" + '><span class=' + "'map-popup-title'" + '><strong>' + title + '</strong></span><br/><div>' + city + '</div><div>' + province + '</div><div><a href=' + "'" + url + "'" + ' target=' + "'" + '_blank' + "'" + '>' + url + '</a></div><div>' + country + '</div></div > "}';
                } else if (isChemicalDistributor) {
                    eventInfo = '{"image": "' + pinImage + '","details": "<b>' + title + '</b>","position": { "latitude": ' + item.Latitude + ', "longitude": ' + item.Longitude + '}, "popup": "<div class=' + "'map-popup-info'" + '><span class=' + "'map-popup-title'" + '><strong>' + title + '</strong></span><br/><div>' + city + '</div><div>' + province + '</div><div>' + phone + '</div><div><a href=' + "'" + url + "'" + 'onclick=GTMDistributorDetailsExternalMapClick(' + "'" + url + "'" + ')  target=' + "'" + '_blank' + "'" + '>' + url + '</a></div><div>' + country + '</div></div > "}';
                } else {
                    eventInfo = '{"details": "<b>' + title + '</b>","position": { "latitude": ' + item.Latitude + ', "longitude": ' + item.Longitude + '}, "popup": "<div class=' + "'map-popup-info'" + '><span class=' + "'map-popup-title'" + '><strong>' + title + '</strong></span><br/><div>' + city + '</div><div>' + province + '</div><div><a href=' + "'" + url + "'" + ' target=' + "'" + '_blank' + "'" + '>' + url + '</a></div><div>' + country + '</div></div > "}';
                }

                pinsList.push(eventInfo);
            }
        });
        var pinsListStr = '[' + pinsList.join(',') + ']';
        return JSON.parse(pinsListStr);
    }
}

//from custom componet.js
(function ($) {
    var i = 0;
    var timer = setInterval(function () {
        i++;
        var element = $(".product-selector");
        if (element.length > 0) {
            $(".product-selector-spinner").hide();
            clearInterval(timer);
        }
        if (i === 10) clearInterval(timer);
    }, 1000);
}(window.jQuery));

/*analytics*/
analytics.eventConfig.push(
    {
        "target": ".map-popup",
        "events": [
            {
                "eventTarget": "OnSuccessfulMapClick",
                "eventType": "click",
                "tags": {
                    //merged from chemicals
                    'event1': 'gaCustomEvents_distributor_locator',
                    'eventCategory': 'Customer Enablement & Education',
                    'eventAction': 'Visited Distributor Site',
                    'eventLabel': "",
                    'external_url': "",
                    'page_type': 'Distributor Page',
                    'page_title': 'Distributor Locator',
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                }
            }
        ]
    },
);